$(document).ready(function() {
    $(window).on('scroll', function() {
        if ($(window).scrollTop() > 50) {
            $('header').addClass('scrolled');
        } else {
            $('header').removeClass('scrolled');
        }
    });

    $(document).on("click", "button.previous-btn-slider-wrap", function() {
        $(this)
            .parents("product-recommendations")
            .find("button.slick-prev.slick-arrow")
            .click();
    });

    $(document).on("click", "button.next-btn-slider-wrap", function() {
        $(this)
            .parents("product-recommendations")
            .find("button.slick-next.slick-arrow")
            .click();
    });
    
    if ($('.js-slick-reviews').length > 0 && !$('.js-slick-reviews').hasClass('slick-initialized')) {
    
    $('.js-slick-reviews').slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      infinite: true,
      autoplay: true,
      autoplaySpeed: 1500,
      arrows: false,
      dots: false,
      // centerMode: true, // dono side half slide show karne ke liye
      // centerPadding: '180px', // left-right half visible area

      responsive: [
        {
          breakpoint: 1440,
          settings: {
            slidesToShow: 3,
            // centerPadding: '120px'
          }
        },
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            // centerPadding: '30px'
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
            // centerPadding: '30px'
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: false,
            // centerPadding: '30px'
          }
        }
      ]
    });
    
  }

  if (!customElements.get('price-range-slider')) {
    customElements.define('price-range-slider', class extends HTMLElement {
      connectedCallback() {
        this.minSlider = this.querySelector('.range-min');
        this.maxSlider = this.querySelector('.range-max');
        this.minInput = this.querySelector('.min-price-input');
        this.maxInput = this.querySelector('.max-price-input');
        this.track = this.querySelector('.slider-track');

        if (!this.minSlider || !this.maxSlider || !this.minInput || !this.maxInput) return;

        // Ensure max limit is set properly
        this.maxLimit = this.parseMoney(this.maxInput.getAttribute('data-max')) || 1000;
        this.minSlider.max = this.maxLimit;
        this.maxSlider.max = this.maxLimit;

        // Set initial values
        this.minSlider.value = this.parseMoney(this.minInput.value) || 0;
        let currentMax = this.parseMoney(this.maxInput.value);
        this.maxSlider.value = currentMax > 0 ? currentMax : this.maxLimit;

        this.updateTrack();

        // Bind events
        this.minSlider.addEventListener('input', this.handleMinInput.bind(this));
        this.maxSlider.addEventListener('input', this.handleMaxInput.bind(this));
        this.minInput.addEventListener('change', this.handleMinInputChange.bind(this));
        this.maxInput.addEventListener('change', this.handleMaxInputChange.bind(this));

        // Trigger Shopify Facet reload on drop
        this.minSlider.addEventListener('change', () => this.minInput.dispatchEvent(new Event('change', { bubbles: true })));
        this.maxSlider.addEventListener('change', () => this.maxInput.dispatchEvent(new Event('change', { bubbles: true })));
      }

      parseMoney(value) {
        if (!value || value.trim() === '') return 0;
        let cleanStr = value.toString().replace(/[^0-9.,]/g, '');
        if (!cleanStr) return 0;
        
        let lastCommaPos = cleanStr.lastIndexOf(',');
        let lastDotPos = cleanStr.lastIndexOf('.');
        if (lastCommaPos > lastDotPos) {
           cleanStr = cleanStr.replace(/\./g, '').replace(',', '.');
        } else {
           cleanStr = cleanStr.replace(/,/g, '');
        }
        return parseFloat(cleanStr) || 0;
      }

      updateTrack() {
        let maxLimSafeguard = this.maxLimit > 0 ? this.maxLimit : 1;
        let percent1 = (this.minSlider.value / maxLimSafeguard) * 100;
        let percent2 = (this.maxSlider.value / maxLimSafeguard) * 100;
        
        // Safety check to ensure visually it stays within bounds
        if (percent1 < 0) percent1 = 0;
        if (percent2 > 100) percent2 = 100;

        this.track.style.left = percent1 + '%';
        this.track.style.width = (percent2 - percent1) + '%';
      }

      handleMinInput() {
        if (parseFloat(this.minSlider.value) >= parseFloat(this.maxSlider.value)) {
          this.minSlider.value = parseFloat(this.maxSlider.value) - 1;
        }
        this.updateTrack();
        this.minInput.value = this.minSlider.value;
      }

      handleMaxInput() {
        if (parseFloat(this.maxSlider.value) <= parseFloat(this.minSlider.value)) {
          this.maxSlider.value = parseFloat(this.minSlider.value) + 1;
        }
        this.updateTrack();
        this.maxInput.value = this.maxSlider.value;
      }

      handleMinInputChange() {
         this.minSlider.value = this.parseMoney(this.minInput.value);
         this.updateTrack();
      }

      handleMaxInputChange() {
         this.maxSlider.value = this.parseMoney(this.maxInput.value);
         this.updateTrack();
      }
    });
  }


    // Check if jQuery and Slick exist before initializing
    if (typeof jQuery !== 'undefined' && jQuery.fn.slick) {
      jQuery('.popular-posts-slick').slick({
        dots: false,
        arrows: false,
        infinite: true,         // Required for center mode to loop properly
        autoplay: true,         // Autoscroll enabled
        autoplaySpeed: 3000,    // 3 seconds per slide
        centerMode: true,       // Center Mode enabled
        centerPadding: '500px',  // Side padding for center mode
        slidesToShow: 1,        // Shows 3 blocks
        slidesToScroll: 1,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 1,
              centerMode: true,
              centerPadding: '30px'
            }
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 1,
              centerMode: true,
              centerPadding: '20px'
            }
          }
        ]
      });
    }

  //         document.addEventListener("click", function (e) {
  //   if (e.target && e.target.id === "load-more") {

  //     let itemsPerClick = 3;
  //     let hiddenItems = document.querySelectorAll(".grid__item.hidden");

  //     console.log("Hidden found:", hiddenItems.length); // debug

  //     for (let i = 0; i < itemsPerClick && i < hiddenItems.length; i++) {
  //       hiddenItems[i].classList.remove("hidden");
  //     }

  //     if (document.querySelectorAll(".grid__item.hidden").length === 0) {
  //       e.target.style.display = "none";
  //     }
  //   }
  // });


  // Global variables
  let isFetching = false;
  let allLoaded = false;
  let nextUrl = null;

  // STEP 1: Initialization logic ko ek function mein wrap kar diya
  function initInfiniteScroll() {
    // Purane loaders/messages agar hain toh clean kar do
    $('.custom-loader, .no-more-products').remove();

    let $paginationWrapper = $('.pagination-wrapper'); 
    let $nextButton = $paginationWrapper.find('a[aria-label="Next page"]');
    
    // Naya next URL set karo (Filter ke baad ka naya link)
    nextUrl = $nextButton.length > 0 ? $nextButton.attr("href") : null;
    $paginationWrapper.hide();

    // Loader aur message wapas grid ke baad laga do
    $('ul.grid.product-grid').after('<div class="custom-loader" style="display:none;"><div class="spinner"></div></div><div class="no-more-products" style="display:none;">You have viewed all products!</div>');

    isFetching = false;

    if (!nextUrl) {
        allLoaded = true;
    } else {
        allLoaded = false;
    }
  }

  // Pehli baar page load hone pe initialize karo
  initInfiniteScroll();

  // STEP 2: MutationObserver - Yeh DOM changes ko observe karega (Filter changes detect karne ke liye)
  let gridObserver = new MutationObserver(function(mutations) {
      let $grid = $('ul.grid.product-grid');
      // Agar grid available hai par hamara loader gayab ho gaya (matlab AJAX filter ne HTML replace kar diya hai)
      if ($grid.length > 0 && $('.custom-loader').length === 0) {
          initInfiniteScroll(); // Script ko naye filtered data ke hisaab se reset karo
      }
  });

  // #ProductGridContainer ya body pe observer laga do
  let observerTarget = document.querySelector('#ProductGridContainer') || document.querySelector('body');
  if (observerTarget) {
      gridObserver.observe(observerTarget, { childList: true, subtree: true });
  }

  // STEP 3: Scroll Event (Aapka logic wahi hai, bas classes thodi optimize ki hain)
  $(window).on("scroll", function () {
    if (allLoaded || isFetching || !nextUrl) return;

    let scrollPosition = $(window).scrollTop() + $(window).height();
    let documentHeight = $(document).height();

    // Scroll 600px pehle trigger hoga
    if (scrollPosition >= documentHeight - 600) {
      isFetching = true;
      $('.custom-loader').css('display', 'block');

      $.ajax({
        url: nextUrl,
        type: 'GET',
        dataType: 'html',
        success: function (response) {
          let $html = $(response);
          let $newProducts = $html.find('ul.grid.product-grid .grid__item'); 

          $newProducts.each(function (index) {
            let $item = $(this);
            $item.addClass('show-effect');
            $item.css('animation-delay', (index * 0.1) + 's');
          });

          $('ul.grid.product-grid').append($newProducts);

          // Naye HTML mein se agla page dhoondo
          let $newNextBtn = $html.find('.pagination-wrapper a[aria-label="Next page"]');
          
          if ($newNextBtn.length > 0) {
            nextUrl = $newNextBtn.attr("href");
          } else {
            nextUrl = null;
            allLoaded = true;
            $('.no-more-products').css('display', 'block');
          }

          $('.custom-loader').css('display', 'none');
          isFetching = false;
        },
        error: function () {
          console.log("Error loading next page");
          $('.custom-loader').css('display', 'none');
          isFetching = false;
        }
      });
    }
  });



  if ($(window).width() >= 1090) {
    let hoverTimer; // Menu close hone ka timer
    
    $('header-menu details').hover(
      function() {
        // --- MOUSE ENTER (Hover In) ---
        let $details = $(this);
        
        clearTimeout(hoverTimer); // Puran close timer rok do
        
        // ⚠️ NEW FIX: Jis par hover kiya hai usko chhod kar, baaki sabko turant band kar do
        $('header-menu details').not($details)
          .removeClass('hover-active-menu')
          .removeAttr('open')
          .find('summary').attr('aria-expanded', 'false');
        
        // Ab current menu ko open karo
        $details.attr('open', '');
        $details.find('summary').attr('aria-expanded', 'true');
        
        // Animation smoothly laane ke liye thoda gap
        setTimeout(function() {
          $details.addClass('hover-active-menu');
        }, 10);
      },
      function() {
        // --- MOUSE LEAVE (Hover Out) ---
        let $details = $(this);
        
        // Animation class hatao (fade out effect ke liye)
        $details.removeClass('hover-active-menu');
        
        // 300ms wait karke HTML se bhi hata do (taaki mouse submenu tak ja sake)
        hoverTimer = setTimeout(function() {
          $details.removeAttr('open');
          $details.find('summary').attr('aria-expanded', 'false');
        }, 300); 
      }
    );

    // Default click event rokne ke liye
    $('header-menu details summary').on('click', function(e) {
      e.preventDefault(); 
    });
  }



});




jQuery(document).ready(function($) {
    function fixAllBlurryImages() {
        $('.card__media img, .collection-card img').each(function() {
            var $img = $(this);
            var currentSrc = $img.attr('src');
            if(currentSrc) {
                var hdSrc = currentSrc.replace(/\?width=\d+/, '');
                hdSrc = hdSrc + (hdSrc.indexOf('?') > -1 ? '&' : '?') + 'width=1200';
                $img.attr('src', hdSrc);
                $img.removeAttr('srcset');
                $img.css('image-rendering', 'high-quality');
            }
        });
        $('.card__media img, .product-card-wrapper img, .media img').each(function() {
            var $img = $(this);
            var originalSrc = $img.attr('src');
            
            if(originalSrc) {
                if(originalSrc.indexOf('cdn.shopify.com') > -1 || originalSrc.indexOf('cdn.shop') > -1) {
                    // Increase quality - force minimum 800px width
                    var fixedSrc = originalSrc.replace(/&width=\d+/, '');
                    fixedSrc = fixedSrc.replace(/\?width=\d+/, '');
                    
                    if(fixedSrc.indexOf('?') > -1) {
                        fixedSrc = fixedSrc + '&width=1000';
                    } else {
                        fixedSrc = fixedSrc + '?width=1000';
                    }
                    $img.attr('src', fixedSrc);
                    $img.removeAttr('srcset');
                    $img.removeAttr('sizes');
                    
                    // Add sharp rendering CSS
                    $img.css({
                        'image-rendering': '-webkit-optimize-contrast',
                        'image-rendering': 'crisp-edges',
                        'image-rendering': 'pixelated'
                    });
                }
            }
        });
      
        $('.media--hover-effect img').each(function() {
            var $img = $(this);
            var src = $img.attr('src');
            if(src && src.indexOf('width=') > -1) {
                var newSrc = src.replace(/width=\d+/, 'width=1000');
                $img.attr('src', newSrc);
            }
        });
    }
    $('.card__media img, .product-card-wrapper img').removeAttr('loading');
    
    // Run fix immediately
    fixAllBlurryImages();
    
    // Run again after a small delay (for lazy loaded images)
    setTimeout(function() {
        fixAllBlurryImages();
    }, 500);
    
    // Run again after 2 seconds (for all images)
    setTimeout(function() {
        fixAllBlurryImages();
    }, 2000);
    
    // Watch for dynamically added products (load more button)
    var observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
            if(mutation.type === 'childList') {
                fixAllBlurryImages();
            }
        });
    });
    
    observer.observe(document.body, {
        childList: true,
        subtree: true
    });
    
    // Also fix when load more button is clicked
    $(document).on('click', '#load-more, .load-more, .pagination__item', function() {
        setTimeout(function() {
            fixAllBlurryImages();
        }, 100);
    });
    
    // Window resize par bhi fix kar do
    $(window).on('resize', function() {
        setTimeout(fixAllBlurryImages, 200);
    });
});




